module.exports = __webpack_public_path__ + "img/highlander.b1298194.png";